import { StyleSpecification } from "maplibre-gl";

const norkartStyleSpecification: StyleSpecification = {
	version: 8,
	sources: {
		map: {
			type: "raster",
			tiles: [`https://maptiles.finncdn.no/tileService/1.0.3/normaphdbright/{z}/{x}/{y}.png`],
			tileSize: 256,
		},
		maphd: {
			type: "raster",
			tiles: [`https://maptiles.finncdn.no/tileService/1.0.3/normaphd/{z}/{x}/{y}.png`],
			tileSize: 256,
		},
		ortho: {
			type: "raster",
			tiles: [`https://maptiles.finncdn.no/tileService/1.0.3/norortho/{z}/{x}/{y}.png`],
			tileSize: 256,
		},
		hybrid: {
			type: "raster",
			tiles: [`https://maptiles.finncdn.no/tileService/1.0.3/norhybrid/{z}/{x}/{y}.png`],
			tileSize: 256,
		},
		poi: {
			type: "vector",
			tiles: [`/api/search/protobuf/{z}/{x}/{y}?autoLimit=true`],
		},
	},
	layers: [
		{
			id: "map",
			type: "raster",
			source: "map",
		},
	],
};

export default norkartStyleSpecification;
